import {HOST_MEDIA_URL_V1} from '../redux/api/urls'
import defaultLogo from '../assets/images/icons/empty_img.png';

export function generateImageMediaUrl(path) {
    if (path?.startsWith('http')) {
        return path;
    }
    return path ? `${HOST_MEDIA_URL_V1}/files${path}` : defaultLogo;
}
